import { render, staticRenderFns } from "./c증표구입완료.vue?vue&type=template&id=74a4d600&scoped=true&"
import script from "./c증표구입완료.vue?vue&type=script&lang=js&"
export * from "./c증표구입완료.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmjs.org/vue-loader/15.8.3_25647bdc581bdda9c9b762adc3f55a51/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a4d600",
  null
  
)

export default component.exports